export default __webpack_public_path__ + "static/media/degot-screenshot-06.d19f42e9.png";